import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../constants/routes'

import PublicNav from '../layout/public-nav'

import Home from './home'

import ContactInfo from './contact-info'
import InquiryLanding from './inquire/index'
import PrivateDinnerInquiry from './inquire/private-dinner'
import MultiDayInquiry from './inquire/multi-day'
import WeeklyMealsInquiry from './inquire/weekly-meals'
import Register from './register'
import Login from './auth/login'
import Logout from './auth/logout'
import AuthRouter from './auth/auth-router'
import AuthHandler from './auth/auth-handler'
import PasswordHelp from './auth/password-help'
import PasswordReset from './auth/password-reset'
import CreateUser from './create-user'

// import NotFound from './not-found'

const PublicIndex = (props) => {
    const { fireauth } = props
    const { pathname } = useLocation()
    // the client-facing doors carry the logo in their own box, so they skip the nav bar;
    // signed-in chefs and admins reach their areas through the home page's Chef Login card.
    // the trailing slash lets /reserve match the same as /reserve/
    const showNav = pathname !== routes.publicIndex.path && !`${pathname}/`.startsWith(routes.inquiryIndex.path)

    return (
        <>
            {showNav && <PublicNav />}
            <div id="public-wrapper" className={showNav ? '' : 'no-nav'}>
                <Routes>
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.contactInfo.path)} element={<ContactInfo />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.createEvent.path)} element={<Navigate to={routes.inquiryIndex.path} replace />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.inquiryPrivateDinner.path)} element={<PrivateDinnerInquiry />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.inquiryMultiDay.path)} element={<MultiDayInquiry />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.inquiryWeeklyMeals.path)} element={<WeeklyMealsInquiry />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.inquiryIndex.path)} element={<InquiryLanding />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authRegister.path)} element={<Register fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authLogin.path)} element={<Login fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.createUser.path)} element={<CreateUser />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authLogout.path)} element={<Logout fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authRouter.path)} element={<AuthRouter fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authHandler.path)} element={<AuthHandler fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authPasswordHelp.path)} element={<PasswordHelp fireauth={fireauth} />} />
                    <Route path={nestedRoutePath(routes.publicIndex.path, routes.authPasswordReset.path)} element={<PasswordReset fireauth={fireauth} />} />
                    <Route index element={<Home />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Routes>
            </div>
        </>
    )
}

export default PublicIndex
